// Aspect-ratio "formats" surfaced on Step 2 when the user picked the
// "Product Shot" category on Step 1. These aren't tied to any social
// platform — just the output's aspect ratio + pixel dimensions. The
// downstream wizard treats these like platforms (same lookup shape, same
// id-based selection), but the labels read as formats so users aren't
// confused into thinking they're posting to "1:1 / Instagram".
// Fashion-route models — used by Step 4 of the Fashion route (the "pick a
// model" step that replaces the Background step). Each entry references
// assets in /public/fashion-templates/<folder>/. The base.png shows the
// model wearing a placeholder outfit; the three masks define the regions
// that get replaced with the user's uploaded garment (top / bottoms /
// shoes). Garment type is auto-detected from the upload, then we pick the
// matching mask.
//
// All masks are 1024×1024 RGBA with real alpha transparency. Verified via
// the bg-alpha check script before wiring.
export type FashionGarmentType = 'top' | 'bottoms' | 'shoes';

export type FashionModel = {
  id: string;
  name: string;
  vibe: string;          // short style descriptor for the card
  folder: string;        // matches Frontend/public/fashion-templates/<folder>/
  base: string;          // filename of the model photo
  masks: Record<FashionGarmentType, string>;  // filename per garment region
};

export const fashionModels: FashionModel[] = [
  {
    id: 'model-1',
    name: 'Concrete Wall Lean',
    vibe: 'Streetwear · masculine',
    folder: 'Model-1',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-2',
    name: 'Studio Model 2',
    vibe: 'Editorial · neutral',
    folder: 'Model-2',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-3',
    name: 'Studio Model 3',
    vibe: 'Lookbook · classical',
    folder: 'Model-3',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-4',
    name: 'Studio Model 4',
    vibe: 'Editorial · neutral',
    folder: 'Model-4',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-5',
    name: 'Studio Model 5',
    vibe: 'Lookbook · classical',
    folder: 'Model-5',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-6',
    name: 'Studio Model 6',
    vibe: 'Streetwear · masculine',
    folder: 'Model-6',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-7',
    name: 'Studio Model 7',
    vibe: 'Editorial · neutral',
    folder: 'Model-7',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-8',
    name: 'Studio Model 8',
    vibe: 'Lookbook · classical',
    folder: 'Model-8',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-9',
    name: 'Studio Model 9',
    vibe: 'Streetwear · masculine',
    folder: 'Model-9',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-10',
    name: 'Studio Model 10',
    vibe: 'Editorial · neutral',
    folder: 'Model-10',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-11',
    name: 'Studio Model 11',
    vibe: 'Lookbook · classical',
    folder: 'Model-11',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-12',
    name: 'Studio Model 12',
    vibe: 'Streetwear · masculine',
    folder: 'Model-12',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-13',
    name: 'Studio Model 13',
    vibe: 'Editorial · neutral',
    folder: 'Model-13',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-14',
    name: 'Studio Model 14',
    vibe: 'Lookbook · classical',
    folder: 'Model-14',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-15',
    name: 'Studio Model 15',
    vibe: 'Streetwear · masculine',
    folder: 'Model-15',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-16',
    name: 'Studio Model 16',
    vibe: 'Editorial · neutral',
    folder: 'Model-16',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
  {
    id: 'model-17',
    name: 'Studio Model 17',
    vibe: 'Lookbook · classical',
    folder: 'Model-17',
    base: 'base.png',
    masks: { top: 'mask_top.png', bottoms: 'mask_bottoms.png', shoes: 'mask_shoes.png' },
  },
];

/** Get the full public path for a fashion asset (base or mask). */
export function fashionAssetUrl(model: FashionModel, file: string): string {
  return `/fashion-templates/${model.folder}/${file}`;
}

// ---------------------------------------------------------------------------
// Product Swap route — model/hand holds a placeholder product; we swap in the
// user's via the mask-based edit pipeline (backend `is_product_swap` branch,
// using each template's frame1_empty.png + mask.png). Promoted from the
// Product Shot "In Hand" aesthetic group on May 29, 2026; templates 23–27 are
// the seed set.
//
// Adding a Product Swap template:
//   1. drop frame1_empty.png + mask.png + frame1_thumb.png in
//      frontend/public/templates/<id>/ AND backend/templates/<id>/
//   2. add <id> to PRODUCT_SWAP_TEMPLATES in backend/main.py
//   3. append a ProductSwapScene entry below with its silhouettes
// ---------------------------------------------------------------------------

// Product form-factor families. Mirrors the analyze-product `productSilhouette`
// vocabulary so a detected product can be matched to scenes whose placeholder
// holds a similar shape (a tall serum bottle and a squat cream jar fill the
// mask very differently — matching shape is the main quality lever).
export type ProductSilhouette =
  | 'tall-bottle'
  | 'pump-bottle'
  | 'dropper'
  | 'short-jar'
  | 'tube'
  | 'box'
  | 'other';

// Display labels for the silhouette filter chips in the picker.
export const SILHOUETTE_LABELS: Record<ProductSilhouette, string> = {
  'tall-bottle': 'Tall bottle',
  'pump-bottle': 'Pump bottle',
  'dropper': 'Dropper',
  'short-jar': 'Jar / tub',
  'tube': 'Tube',
  'box': 'Box / carton',
  'other': 'Other',
};

export type ProductSwapScene = {
  id: string;          // backend templateId — MUST be in PRODUCT_SWAP_TEMPLATES
  name: string;
  vibe: string;        // short descriptor for the card
  thumb: string;       // picker preview (public path)
  /** Silhouettes this scene's held placeholder suits. Drives the picker's
   *  "Best for your product" group from the detected productSilhouette. */
  silhouettes: ProductSilhouette[];
};

// Seed set = the 5 former "In Hand" templates. Silhouettes were assigned by
// inspecting each frame1_thumb.png placeholder (May 29, 2026). Note t27's
// legacy demo.ts name was "Pastel Studio" but the asset is a dark-backdrop
// dropper shot — corrected here.
export const productSwapScenes: ProductSwapScene[] = [
  {
    id: 'template23',
    name: 'Studio White',
    vibe: 'Clean white studio · held upright',
    thumb: '/templates/template23/frame1_thumb.png',
    silhouettes: ['tall-bottle', 'pump-bottle'],
  },
  {
    id: 'template24',
    name: 'Editorial Closeup',
    vibe: 'Model close-up near the face',
    thumb: '/templates/template24/frame1_thumb.png',
    silhouettes: ['tube'],
  },
  {
    id: 'template25',
    name: 'Warm Bokeh',
    vibe: 'Dreamy warm out-of-focus glow',
    thumb: '/templates/template25/frame1_thumb.png',
    silhouettes: ['short-jar'],
  },
  {
    id: 'template26',
    name: 'Marble Counter',
    vibe: 'Hand resting on Carrara marble',
    thumb: '/templates/template26/frame1_thumb.png',
    silhouettes: ['short-jar'],
  },
  {
    id: 'template27',
    name: 'Dark Dropper',
    vibe: 'Moody black backdrop · dropper bottle',
    thumb: '/templates/template27/frame1_thumb.png',
    silhouettes: ['dropper', 'tall-bottle'],
  },
];

// Platform "badge" shown on a Product Shot format card to indicate which
// real-world social platforms use that aspect ratio at the listed size.
// Purely informational — clicking a format card still selects on the
// format id, not a specific platform. Specs current as of 2026.
export type FormatPlatform = {
  name: string;
  icon: string;   // Remix Icon class
  color: string;  // brand color, used for icon tint
};

export const productShotFormats = [
  {
    id: 'shot-1x1',
    name: 'Square',
    handle: '1:1',
    icon: 'ri-square-line',
    aspectRatio: '1:1',
    dimensions: '1080 × 1080',
    color: '#4A4A5E',
    preview: { width: '72px', height: '72px' },
    // Square 1:1 is still the safe-everywhere format. Instagram has
    // moved its feed default to 4:5, but 1:1 still posts cleanly on
    // every surface listed below.
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
      { name: 'X',         icon: 'ri-twitter-x-line',       color: '#0F1419' },
      { name: 'LinkedIn',  icon: 'ri-linkedin-box-line',    color: '#0A66C2' },
      { name: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
    ] as FormatPlatform[],
  },
  {
    id: 'shot-4x5',
    name: 'Portrait',
    handle: '4:5',
    icon: 'ri-rectangle-line',
    aspectRatio: '4:5',
    dimensions: '1080 × 1350',
    color: '#4A4A5E',
    preview: { width: '60px', height: '75px' },
    // 4:5 is Instagram's current preferred feed format (max vertical
    // real-estate without cropping); also clean on FB feed.
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
    ] as FormatPlatform[],
  },
  {
    id: 'shot-9x16',
    name: 'Vertical',
    handle: '9:16',
    icon: 'ri-smartphone-line',
    aspectRatio: '9:16',
    dimensions: '1080 × 1920',
    color: '#4A4A5E',
    preview: { width: '48px', height: '85px' },
    // Full-screen vertical — Reels, Stories, Shorts, TikTok feed.
    platforms: [
      { name: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'YouTube',   icon: 'ri-youtube-line',         color: '#FF0000' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
    ] as FormatPlatform[],
  },
  {
    id: 'shot-16x9',
    name: 'Widescreen',
    handle: '16:9',
    icon: 'ri-tv-line',
    aspectRatio: '16:9',
    dimensions: '1920 × 1080',
    color: '#4A4A5E',
    preview: { width: '96px', height: '54px' },
    // Full-HD landscape — YouTube thumbnails / X video / LinkedIn video.
    platforms: [
      { name: 'YouTube',  icon: 'ri-youtube-line',      color: '#FF0000' },
      { name: 'X',        icon: 'ri-twitter-x-line',    color: '#0F1419' },
      { name: 'LinkedIn', icon: 'ri-linkedin-box-line', color: '#0A66C2' },
    ] as FormatPlatform[],
  },
];

// Video gen output formats (videoFormats array) were removed on May 26, 2026
// when the video route was stripped. See VIDEO-RESEARCH.md at the repo root
// for the full R&D archive — the Veo Fast pipeline, the multi-shot studio
// POC, and the product-preservation issue that blocked the launch.

// Social Post format cards (Single Social Media Post route — postType
// 'single'). Mirrors `productShotFormats`: one card per aspect ratio,
// each with a row of brand icons showing which platforms use that size.
// Replaces the previous "one card per platform" model (13 cards →
// 3 cards) which was redundant since several platforms share each ratio.
//
// Active 1:1 covers the 5 main feeds. 4:5 + 9:16 stay "Coming soon"
// until the matching JSON design templates are authored — clicking them
// is a no-op on the picker (StepPlatform's `available: false` gate).
//
// Notes:
//   - Dimensions are the "max useful" pixel size at that aspect (LinkedIn
//     uses 1200 for 1:1; everyone else accepts 1080 cleanly at any size).
//   - Carousel route uses its own multi-frame platforms (instagram-carousel
//     etc. below) — those stay distinct because each carousel platform has
//     different stitching behavior + ad spec.
export const socialPostFormats = [
  {
    id: 'social-1x1',
    name: 'Square Post',
    handle: '1:1',
    icon: 'ri-square-line',
    aspectRatio: '1:1',
    dimensions: '1080 × 1080',
    color: '#4A4A5E',
    preview: { width: '72px', height: '72px' },
    available: true,
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
      { name: 'X',         icon: 'ri-twitter-x-line',       color: '#0F1419' },
      { name: 'LinkedIn',  icon: 'ri-linkedin-box-line',    color: '#0A66C2' },
      { name: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
    ] as FormatPlatform[],
  },
  {
    id: 'social-4x5',
    name: 'Portrait Post',
    handle: '4:5',
    icon: 'ri-rectangle-line',
    aspectRatio: '4:5',
    dimensions: '1080 × 1350',
    color: '#4A4A5E',
    preview: { width: '60px', height: '75px' },
    // 4:5 is IG's preferred feed aspect (max real estate without crop).
    // Coming soon — pending 4:5 JSON design template variants.
    available: false,
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
    ] as FormatPlatform[],
  },
  {
    id: 'social-9x16',
    name: 'Story / Vertical',
    handle: '9:16',
    icon: 'ri-smartphone-line',
    aspectRatio: '9:16',
    dimensions: '1080 × 1920',
    color: '#4A4A5E',
    preview: { width: '48px', height: '85px' },
    // Full-screen vertical for Stories + TikTok feed. Coming soon —
    // pending 9:16 JSON design template variants.
    available: false,
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
      { name: 'LinkedIn',  icon: 'ri-linkedin-box-line',    color: '#0A66C2' },
      { name: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
    ] as FormatPlatform[],
  },
];

// Shared format options used by Fashion + Product Swap routes. Both
// routes are 1:1-locked in v1 because their mask-based pipelines
// require hand-authored model/scene assets at the target aspect — and
// only 1024×1024 versions exist today. The 4:5 + 9:16 tiles render as
// "Coming soon" so users see the roadmap without being able to pick
// them; 16:9 is intentionally omitted (awkward for human-subject
// content like fashion + product-holds).
//
// When new aspect-specific assets are authored, flip `available: true`
// on the relevant tile and the route's Quality + Preview steps will
// pick up the aspect via the standard backend size/crop pipeline.
export const lockedSquareFormats = [
  {
    id: 'locked-1x1',
    name: 'Square',
    handle: '1:1',
    icon: 'ri-square-line',
    aspectRatio: '1:1',
    // 1080×1080 matches every other 1:1 tile (Product Shot, Social Post)
    // and the social-platform "1080-square" standard. The actual file
    // bytes OpenAI returns are 1024×1024 (native gpt-image-1 size, also
    // what the model/scene mask assets are authored at). 1024 vs 1080 is
    // invisible at display sizes and every platform accepts either. If
    // we ever need true 1080 output (e.g. for a print-quality export),
    // add a Pillow upscale after the OpenAI edit in /api/generate.
    dimensions: '1080 × 1080',
    color: '#4A4A5E',
    preview: { width: '72px', height: '72px' },
    available: true,
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
      { name: 'LinkedIn',  icon: 'ri-linkedin-box-line',    color: '#0A66C2' },
      { name: 'X',         icon: 'ri-twitter-x-line',       color: '#0F1419' },
      { name: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
    ] as FormatPlatform[],
  },
  {
    id: 'locked-4x5',
    name: 'Portrait',
    handle: '4:5',
    icon: 'ri-rectangle-line',
    aspectRatio: '4:5',
    dimensions: '1080 × 1350',
    color: '#4A4A5E',
    preview: { width: '60px', height: '75px' },
    // Coming soon — requires per-aspect model/scene authoring.
    available: false,
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
    ] as FormatPlatform[],
  },
  {
    id: 'locked-9x16',
    name: 'Vertical',
    handle: '9:16',
    icon: 'ri-smartphone-line',
    aspectRatio: '9:16',
    dimensions: '1080 × 1920',
    color: '#4A4A5E',
    preview: { width: '48px', height: '85px' },
    // Coming soon — requires per-aspect model/scene authoring.
    available: false,
    platforms: [
      { name: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
      { name: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
    ] as FormatPlatform[],
  },
];

export const socialPlatforms = [
  // ---- Carousel platforms (4-frame Multi-badged — used by Carousel route) ----
  {
    id: 'instagram-carousel',
    name: 'Instagram Carousel',
    handle: 'carousel',
    icon: 'ri-gallery-view-2',
    aspectRatio: '1:1',
    dimensions: '1080 x 1080',
    color: '#E4405F',
    preview: { width: '72px', height: '72px' },
    badge: 'Multi',
    available: true,
  },
  {
    id: 'facebook-carousel',
    name: 'Facebook Carousel',
    handle: 'carousel',
    icon: 'ri-facebook-circle-line',
    aspectRatio: '1:1',
    dimensions: '1080 x 1080',
    color: '#1877F2',
    preview: { width: '72px', height: '72px' },
    badge: 'Multi',
    available: true,
  },
  {
    id: 'linkedin-carousel',
    name: 'LinkedIn Carousel',
    handle: 'carousel',
    icon: 'ri-linkedin-box-line',
    aspectRatio: '1:1',
    dimensions: '1080 x 1080',
    color: '#0A66C2',
    preview: { width: '72px', height: '72px' },
    badge: 'Multi',
    available: true,
  },

  // ---- Single Social Media Post — ACTIVE (1:1 square) ----
  // Each design template renders at 1080×1080 reference; export pixelRatio
  // scales to the platform's native size on download.
  {
    id: 'instagram',
    name: 'Instagram Post',
    handle: 'post',
    icon: 'ri-instagram-line',
    aspectRatio: '1:1',
    dimensions: '1080 x 1080',
    color: '#E4405F',
    preview: { width: '72px', height: '72px' },
    available: true,
  },
  {
    id: 'facebook',
    name: 'Facebook Post',
    handle: 'post',
    icon: 'ri-facebook-circle-line',
    aspectRatio: '1:1',
    dimensions: '1080 x 1080',
    color: '#1877F2',
    preview: { width: '72px', height: '72px' },
    available: true,
  },
  {
    id: 'x',
    name: 'X Post',
    handle: 'post',
    icon: 'ri-twitter-x-line',
    aspectRatio: '1:1',
    dimensions: '1080 x 1080',
    color: '#0F1419',
    preview: { width: '72px', height: '72px' },
    available: true,
  },
  {
    id: 'linkedin',
    name: 'LinkedIn Post',
    handle: 'post',
    icon: 'ri-linkedin-box-line',
    aspectRatio: '1:1',
    dimensions: '1200 x 1200',
    color: '#0A66C2',
    preview: { width: '72px', height: '72px' },
    available: true,
  },
  {
    id: 'tiktok',
    name: 'TikTok Post',
    handle: 'post',
    icon: 'ri-tiktok-line',
    aspectRatio: '1:1',
    dimensions: '640 x 640',
    color: '#0F0F0F',
    preview: { width: '72px', height: '72px' },
    available: true,
  },

  // ---- COMING SOON (vertical / stories — pending 4:5 + 9:16 design variants) ----
  // Rendered as disabled cards with a "Coming soon" badge.
  {
    id: 'instagram-portrait',
    name: 'Instagram Portrait',
    handle: 'portrait',
    icon: 'ri-instagram-line',
    aspectRatio: '4:5',
    dimensions: '1080 x 1350',
    color: '#E4405F',
    preview: { width: '60px', height: '75px' },
    available: false,
  },
  {
    id: 'instagram-story',
    name: 'Instagram Story',
    handle: 'story',
    icon: 'ri-instagram-line',
    aspectRatio: '9:16',
    dimensions: '1080 x 1920',
    color: '#E4405F',
    preview: { width: '48px', height: '85px' },
    available: false,
  },
  {
    id: 'facebook-story',
    name: 'Facebook Story',
    handle: 'story',
    icon: 'ri-facebook-circle-line',
    aspectRatio: '9:16',
    dimensions: '1080 x 1920',
    color: '#1877F2',
    preview: { width: '48px', height: '85px' },
    available: false,
  },
  {
    id: 'linkedin-story',
    name: 'LinkedIn Story',
    handle: 'story',
    icon: 'ri-linkedin-box-line',
    aspectRatio: '9:16',
    dimensions: '1080 x 1920',
    color: '#0A66C2',
    preview: { width: '48px', height: '85px' },
    available: false,
  },
  {
    id: 'tiktok-vertical',
    name: 'TikTok Vertical',
    handle: 'vertical',
    icon: 'ri-tiktok-line',
    aspectRatio: '9:16',
    dimensions: '1080 x 1920',
    color: '#0F0F0F',
    preview: { width: '48px', height: '85px' },
    available: false,
  },
];

// Product arrangement patterns — alternative to scene backgrounds on
// StepBackground for the Product Shot route. When a pattern is picked,
// the backend generates a solid-color backdrop (Pillow, in-memory, same
// trick as social-bg-*) and the arrangement directive becomes the
// PRIMARY prompt — no conflicting "match the scene's perspective"
// language to fight against. This is mutually exclusive with scene
// selection: user picks one OR the other.
//
// Each pattern has a `backdropColor` — a tasteful neutral that pairs
// well with the arrangement. Backend's PATTERN_BACKDROPS in main.py
// MUST match these values; keep them in sync if you tweak.
export type ProductArrangement =
  | 'floating-tilt'
  | 'circular-array'
  | 'falling'
  | 'top-down-single'
  | 'low-angle'
  | 'top-down-multi';

export interface ArrangementOption {
  id: ProductArrangement;
  label: string;
  description: string;
  icon: string;             // Remix Icon class
  backdropColor: string;    // Hex incl. '#' — solid color shown behind the product
}

export const productArrangements: ArrangementOption[] = [
  {
    id: 'floating-tilt',
    label: 'Floating tilt',
    description: 'Hovers ~1" above the surface, tilted 15° for a dynamic hero shot.',
    icon: 'ri-arrow-up-circle-line',
    backdropColor: '#F0E8D8',  // warm beige
  },
  {
    id: 'circular-array',
    label: 'Circular array',
    description: '5 duplicates evenly spaced in a ring around a focal point.',
    icon: 'ri-circle-line',
    backdropColor: '#D8E0D0',  // sage
  },
  {
    id: 'falling',
    label: 'Falling',
    description: '3–5 duplicates frozen mid-fall at random positions.',
    icon: 'ri-arrow-down-line',
    backdropColor: '#2C2C2C',  // charcoal — drama against dark
  },
  {
    id: 'top-down-single',
    label: 'Top-down',
    description: 'Overhead view — single product resting on the surface.',
    icon: 'ri-checkbox-blank-line',
    backdropColor: '#F5EFE0',  // cream — flat-lay aesthetic
  },
  {
    id: 'low-angle',
    label: 'Low angle',
    description: 'Dramatic upshot from near ground level — heroic framing.',
    icon: 'ri-triangle-line',
    backdropColor: '#1F1F2E',  // deep navy — sky-like backdrop
  },
  {
    id: 'top-down-multi',
    label: 'Top-down array',
    description: '5 duplicates laid flat in a grid, photographed from directly above.',
    icon: 'ri-grid-line',
    backdropColor: '#F0E8D8',  // warm beige — magazine flat-lay
  },
];

/** Prefix used when a pattern id is serialized as a `template_id` for
 *  the backend. e.g. `pattern-circular-array`. Mirrors the
 *  `social-bg-<designId>` convention from the Social Post route. */
export const PATTERN_TEMPLATE_PREFIX = 'pattern-';

/** True if a template_id refers to one of the pattern arrangements. */
export function isPatternTemplate(templateId: string | null | undefined): boolean {
  return !!templateId && templateId.startsWith(PATTERN_TEMPLATE_PREFIX);
}

/** Friendly label for a pattern template_id, used in sidebar
 *  step-summary lookups (sceneNames doesn't cover pattern ids). */
export function patternNameForTemplateId(templateId: string): string | null {
  if (!isPatternTemplate(templateId)) return null;
  const id = templateId.slice(PATTERN_TEMPLATE_PREFIX.length);
  const opt = productArrangements.find((p) => p.id === id);
  return opt ? `${opt.label} pattern` : null;
}

export const textPresets = [
  { id: 'headline', label: 'Headline', fontSize: 48, fontWeight: 'bold', position: 'center', color: '#FFFFFF' },
  { id: 'subheadline', label: 'Subheadline', fontSize: 32, fontWeight: 'medium', position: 'bottom', color: '#FFFFFF' },
  { id: 'caption', label: 'Caption', fontSize: 20, fontWeight: 'normal', position: 'bottom', color: '#FFFFFF' },
  { id: 'badge', label: 'Badge', fontSize: 16, fontWeight: 'bold', position: 'top', color: '#FFFFFF' },
];

// Snap positions for text overlays. Order is 3x3 grid (row-major: top, middle, bottom).
// Actual placement uses fractional x/y derived from the id; `char` is the unicode glyph
// rendered in the snap-picker buttons.
export const textPositions = [
  { id: 'top-left',     label: 'Top Left',      char: '↖' },
  { id: 'top',          label: 'Top Center',    char: '↑' },
  { id: 'top-right',    label: 'Top Right',     char: '↗' },
  { id: 'center-left',  label: 'Center Left',   char: '←' },
  { id: 'center',       label: 'Center',        char: '●' },
  { id: 'center-right', label: 'Center Right',  char: '→' },
  { id: 'bottom-left',  label: 'Bottom Left',   char: '↙' },
  { id: 'bottom',       label: 'Bottom Center', char: '↓' },
  { id: 'bottom-right', label: 'Bottom Right',  char: '↘' },
];

export const textColors = [
  '#FFFFFF',
  '#0F0F1E',
  '#E02EA5',
  '#5E49D8',
  '#F59E0B',
  '#EF4444',
  '#10B981',
  '#3B82F6',
];